export default __webpack_public_path__ + "static/media/complementary--snow--g5.9cab1800.png";